import { jsx, jsxs } from "react/jsx-runtime";
import {
  DSDialog,
  DSDialogHeader,
  DSDialogBody,
  DSDialogFooter,
  DSDialogSeparator,
  DSDialogTitle,
  DSDialogAddon
} from "@elliemae/ds-dialog";
import { DSControlledRadio } from "@elliemae/ds-form-radio";
import { DSButtonV3 } from "@elliemae/ds-button-v2";
import { Close } from "@elliemae/ds-icons";
import { DSIconColors } from "@elliemae/ds-icon";
import { DSFormLayoutRadioGroup } from "@elliemae/ds-form-layout-blocks";
import { Grid } from "@elliemae/ds-grid";
const AdjustFeeDialog = ({
  open,
  onClose,
  onApply,
  encFeeFactor,
  ppeFeeFactor,
  checkedFactor,
  setCheckedFactor,
  factorValue
}) => {
  return /* @__PURE__ */ jsxs(
    DSDialog,
    {
      isOpen: open,
      onClickOutside: onClose,
      onClose,
      "aria-labelledby": "dialog-title",
      children: [
        /* @__PURE__ */ jsxs(DSDialogHeader, { children: [
          /* @__PURE__ */ jsx(DSDialogTitle, { id: "dialog-title", children: "Adjust Fee Factor" }),
          /* @__PURE__ */ jsx(DSDialogAddon, { children: /* @__PURE__ */ jsx(
            DSButtonV3,
            {
              buttonType: "icon",
              onClick: onClose,
              "aria-label": "close dialog",
              children: /* @__PURE__ */ jsx(Close, { color: DSIconColors.NEUTRAL, title: "close" })
            }
          ) })
        ] }),
        /* @__PURE__ */ jsx(DSDialogSeparator, {}),
        /* @__PURE__ */ jsxs(DSDialogBody, { px: 24, mb: 16, children: [
          "Select the fee factor you want to use for pricing. To change this fee factor to an option not presented, close ICE PPE and update the value in Encompass.",
          /* @__PURE__ */ jsx(Grid, { gutter: "3", children: /* @__PURE__ */ jsxs(DSFormLayoutRadioGroup, { direction: "vertical", children: [
            /* @__PURE__ */ jsx(
              DSControlledRadio,
              {
                checked: checkedFactor === String(encFeeFactor) || factorValue === encFeeFactor && !checkedFactor,
                name: "group",
                label: `${encFeeFactor}% (Encompass Current Value)`,
                value: String(encFeeFactor),
                onChange: setCheckedFactor
              }
            ),
            /* @__PURE__ */ jsx(
              DSControlledRadio,
              {
                checked: checkedFactor === String(ppeFeeFactor) || factorValue === ppeFeeFactor && !checkedFactor,
                name: "group",
                label: `${ppeFeeFactor}% (ICE PPE Value)`,
                value: String(ppeFeeFactor),
                onChange: setCheckedFactor
              }
            )
          ] }) })
        ] }),
        /* @__PURE__ */ jsx(DSDialogSeparator, {}),
        /* @__PURE__ */ jsxs(DSDialogFooter, { children: [
          /* @__PURE__ */ jsx(DSButtonV3, { buttonType: "outline", onClick: onClose, children: "Exit" }),
          /* @__PURE__ */ jsx(DSButtonV3, { onClick: onApply, children: "Apply" })
        ] })
      ]
    }
  );
};
export {
  AdjustFeeDialog
};
